module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.info.participant) ? [_c('span', [_vm._v(_vm._s(_vm.participantSingularName.toUpperCase()) + " NAME: " + _vm._s(_vm.info.participant))]), _c('br'), _c('br')] : _vm._e(), _vm._v(" "), _c('vue-form-view', {
    attrs: {
      "schema": _vm.schema,
      "values": _vm.values
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-info-container"
  }, [(_vm.info.length != 0) ? _c('h4', {
    staticClass: "activity-info"
  }, [_vm._v("ACTIVITY LOGGING")]) : _vm._e(), _vm._v(" "), (_vm.info.created_date != null) ? _c('span', [_vm._v("Completed By: "), _c('b', [_vm._v(_vm._s(_vm.info.creator))]), _vm._v(" at " + _vm._s(_vm._f("formatDate")(_vm.info.created_date.date))), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.isEqual(_vm.info.created_date, _vm.info.updated_date)) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getEditor(_vm.info))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.info.created_date != null) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCase(_vm.info))
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8e6bcb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/print/PrintForm.vue
// module id = 1750
// module chunks = 1